import { useSettingHolidaySpendChallengeCurrentDateOverride } from "@faire/deprecated-retailer-visitor-shared/settings/useSettingHolidaySpendChallengeCurrentDateOverride";
import { useSettingHolidaySpendChallengeEnabled } from "@faire/deprecated-retailer-visitor-shared/settings/useSettingHolidaySpendChallengeEnabled";
import { useSettingHolidaySpendChallengeEndDate } from "@faire/deprecated-retailer-visitor-shared/settings/useSettingHolidaySpendChallengeEndDate";
import { useSettingHolidaySpendChallengeSignUpEndDate } from "@faire/deprecated-retailer-visitor-shared/settings/useSettingHolidaySpendChallengeSignUpEndDate";
import { useSettingHolidaySpendChallengeStartDate } from "@faire/deprecated-retailer-visitor-shared/settings/useSettingHolidaySpendChallengeStartDate";
import { isLocal } from "@faire/web/common/user-agent/isLocal";
import { isStaging } from "@faire/web/common/user-agent/isStaging";
import { isAfter } from "date-fns/isAfter";
import { parseISO as parseDate } from "date-fns/parseISO";

export const useShouldAdvertiseHolidaySpendChallenge = () => {
  const isHolidaySpendChallengeEnabled =
    useSettingHolidaySpendChallengeEnabled();

  const offerStartDate = parseDate(useSettingHolidaySpendChallengeStartDate());
  const offerEndDate = parseDate(useSettingHolidaySpendChallengeEndDate());
  const offerEnrolmentEndDate = parseDate(
    useSettingHolidaySpendChallengeSignUpEndDate()
  );
  const currentDateOverride = parseDate(
    useSettingHolidaySpendChallengeCurrentDateOverride()
  );

  const currentDate =
    isLocal() || isStaging() ? currentDateOverride : new Date();

  const hasOfferStarted = isAfter(currentDate, offerStartDate);
  const hasOfferEnded = isAfter(currentDate, offerEndDate);
  const hasEnrolmentPeriodEnded = isAfter(currentDate, offerEnrolmentEndDate);

  const isOfferActive =
    isHolidaySpendChallengeEnabled && hasOfferStarted && !hasOfferEnded;

  return {
    isOfferActive,
    hasEnrolmentPeriodEnded,
  };
};
